import { Star } from "lucide-react";

export const QR_REVIEW_URL = "https://g.page/r/CQ2jiTZJRmLlEAE/review?utm_source=gbp&utm_medium=reviews&utm_campaign=qr";

export const GoogleReviewQR = ({ id = "qr" }) => (
  <section className="container-x py-12" data-testid={`${id}-section`}>
    <GoogleReviewQRCard id={id} />
  </section>
);

export const GoogleReviewQRCard = ({ id = "qr" }) => (
    <div data-testid={`${id}-card`} className="card-dark flex flex-col items-center gap-8 p-6 sm:p-10 md:flex-row md:justify-center md:gap-14">
      <div className="rounded-xl bg-white p-5 shadow-lg sm:p-6">
        <img src="/images/qr-resena-google.png" alt="Código QR para dejar tu reseña en Google" width="980" height="980" className="block h-64 w-64 sm:h-72 sm:w-72" style={{ imageRendering: "pixelated" }} data-testid={`${id}-image`} />
      </div>
      <div className="max-w-sm text-center md:text-left">
        <p className="eyebrow">Reseñas en Google</p>
        <h2 className="mt-3 text-3xl font-extrabold">Escanea y déjanos tu reseña en Google</h2>
        <p className="mt-3 text-mute">Abre la cámara de tu celular y apunta al código. Tu opinión nos ayuda muchísimo.</p>
        <a href={QR_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="btn-gold mt-6" data-testid={`${id}-link`}><Star size={18} /> O toca aquí para opinar</a>
      </div>
    </div>
);
